import {
	IDeliveryResponse,
	SchemaObject,
	SchemaWrapper,
	minimizeObjects,
	urlCombine,
} from 'ihub/common';
import {
	getTenantID,
	isURLSet,
	schemaServiceAPI,
	standardPost,
	validateOkResponse,
} from '../classes/http-helper-const';
import { cacheStaleTime } from '../constants';
import QueryClientWrapper from '../utils/create-query-client';

export const GetSchemaKey = 'GetSchema';

export class SchemaHttpService {
	getObjectSchemaQuery = (obj: any, arrayOnly = false) => ({
		queryKey: [getTenantID(), GetSchemaKey, arrayOnly],
		queryFn: async (): Promise<SchemaWrapper> => {
			isURLSet();
			const url = urlCombine(schemaServiceAPI, `GetSchema/${arrayOnly}`);
			const result: Response = await standardPost(url, minimizeObjects(obj));
			await validateOkResponse(result, 'get object schema', 'Schema');
			const data: IDeliveryResponse = await result.json();
			if (typeof data.body === 'string') {
				throw new Error(data.body);
			}
			//We are assuming the UI will only request one object schema at a time even though the method can support batches
			const schemaResult = data.body.records[0].processingData as SchemaObject;
			return schemaResult.schema;
		},
		staleTime: cacheStaleTime,
	});

	async invalidateGetAllByUserID(arrayOnly = false) {
		await QueryClientWrapper.InvalidateKey([getTenantID(), GetSchemaKey, arrayOnly], false);
	}
}
